import { formatBillingDate, formatBillingDateOnly } from '../../lib/billingDate'
import type { ExpiringNext } from '../../hooks/credits/useCreditBalance'

/** Prefer billing calendar day (`*_date`); fall back to UTC day of instant. */
export function formatExpiryDisplay(
  isoInstant: string | null | undefined,
  isoDate: string | null | undefined,
  locale: string,
): string | undefined {
  if (isoDate) return formatBillingDateOnly(isoDate, locale)
  if (isoInstant) return formatBillingDate(isoInstant, locale)
  return undefined
}

export function formatExpiringNextDate(
  expiring: ExpiringNext,
  locale: string,
): string | undefined {
  return formatExpiryDisplay(expiring.expires_at, expiring.expires_at_date, locale)
}
